import { __awaiter } from "tslib";
export const pause = (delay) => __awaiter(void 0, void 0, void 0, function* () { return new Promise(resolve => setTimeout(() => resolve(), delay)); });
//# sourceMappingURL=pause.js.map